import * as React from 'react';

import type FetchError from 'logic/errors/FetchError';
import { Row, Col, Alert } from 'components/bootstrap';

const AuthBackendSubmitError = ({ error, backendId }: { error: FetchError; backendId: string | null | undefined }) => (
  <Row>
    <Col xs={9} xsOffset={3}>
      <Alert
        bsStyle="danger"
        style={{ wordBreak: 'break-word' }}
        title={`Failed to ${backendId ? 'edit' : 'create'} authentication service`}>
        {error?.message && (
          <>
            {error.message}
            <br />
            <br />
          </>
        )}
        {error?.additional?.res?.text}
      </Alert>
    </Col>
  </Row>
);

export default AuthBackendSubmitError;
